import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  adminDeleteUserApi,
  getAdminHomeApi,
  getAdminUsersListApi,
  manageDisableUserApi,
} from "helpers/ApiManager";
import { AdminHomeQueryParams } from "types/dashboard.api";
import { AdminUsersQueryParams } from "types/user.api";
import { SuccessToast } from "utils/toast";

export const adminHome = createAsyncThunk(
  "admin/home",
  async (params: AdminHomeQueryParams, { rejectWithValue }) => {
    try {
      const response = await getAdminHomeApi(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const adminUsersList = createAsyncThunk(
  "admin/usersList",
  async (params: AdminUsersQueryParams, { rejectWithValue }) => {
    try {
      const response = await getAdminUsersListApi(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const manageDisableUser = createAsyncThunk(
  "admin/manageDisableUser",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await manageDisableUserApi(id);
      SuccessToast(response?.message || "User status updated successfully");
      return { response, id };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const adminDeleteUser = createAsyncThunk(
  "admin/deleteUser",
  async (userId: number, { rejectWithValue }) => {
    try {
      const response = await adminDeleteUserApi(userId);
      SuccessToast(response?.message || "User deleted successfully");
      return { response, userId };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
